// dynamic-icon.component.ts
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconName } from './icons/icon-map';
import { IconUtilsService } from '../../services/icon-utils.service';

export interface IconMap {
  [key: string]: string;
}

@Component({
  selector: 'app-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit, OnChanges {
  @Input() name!: IconName;
  @Input() size: number = 20;
  @Input() color: string = '#1f1f1f';

  sanitizedSvg: SafeHtml = '';

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly iconUtilsService: IconUtilsService
  ) {}

  ngOnInit() {
    this.updateIcon();
  }

  ngOnChanges() {
    this.updateIcon();
  }

  private updateIcon() {
    const svgContent = this.iconUtilsService.getIcon(
      this.name,
      this.size,
      this.color
    );
    if (svgContent) {
      this.setSanitizedSvg(svgContent);
    } else {
      console.warn(`Ícone '${this.name}' não encontrado`);
      const fallbackSvg = this.iconUtilsService.getIcon(
        'help_outlined',
        this.size,
        this.color
      );
      this.setSanitizedSvg(fallbackSvg);
    }
  }

  /* * JUSTIFICATIVA DE SEGURANÇA: O uso de bypassSecurityTrustHtml é considerado seguro aqui,
   * pois o conteúdo é gerado pela função 'getIcon' do IconUtilsService.
   * Esta função utiliza um mapa interno de SVGs confiáveis e locais. As entradas (name, size, color)
   * são usadas apenas para selecionar um ícone e modificar atributos seguros (width, height, fill),
   * sem risco de injeção de script (XSS).
   */
  private setSanitizedSvg(svgContent: string): void {
    this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(svgContent); // NOSONAR
  }
}
